module.exports = __webpack_public_path__ + "img/spinner-loader.f7d934ea.svg";